import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ClientNames } from './app/clients/client-names.enum';
import { SfAppModule } from './app/clients/sf/sf-app.module';
import { TdAppModule } from './app/clients/td/td-app.module';
import { TdSfAppModule } from './app/clients/td-sf/td-sf-app.module';
import { MobileAppModule } from './app/clients/mobile/mobile-app.module';
import { Es01AppModule } from './app/clients/es01/es01-app.module';
import { Capacitor } from '@capacitor/core';
import { provideAppSdHtmlSanitizer } from './app/core/providers/sd-html-sanitizer.providers';

const applicationProviders = [
  provideZoneChangeDetection(),
  provideAppSdHtmlSanitizer(),
];

if (environment.production) {

  enableProdMode();
}

if (environment.appName === ClientNames.my) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}

if (environment.appName === ClientNames.sf) {
  platformBrowserDynamic()
    .bootstrapModule(SfAppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}

if (environment.appName === ClientNames.tdSf) {
  platformBrowserDynamic()
    .bootstrapModule(TdSfAppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}

if (environment.appName === ClientNames.td) {
  platformBrowserDynamic()
    .bootstrapModule(TdAppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}
if (environment.appName === ClientNames.mobile) {
  // Initialize Eruda for mobile debugging (only in development)

  if (!environment.production && Capacitor.getPlatform() === 'ios') {
    import('eruda').then(eruda => eruda.default.init());
  }

  platformBrowserDynamic()
    .bootstrapModule(MobileAppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}
if (environment.appName === ClientNames.cibc) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}

if (environment.appName === ClientNames.cibcSf) {
  platformBrowserDynamic()
    .bootstrapModule(SfAppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}

if (environment.appName === ClientNames.es01) {
  platformBrowserDynamic()
    .bootstrapModule(Es01AppModule, {
      applicationProviders,
    })
    .catch(err => console.error(err));
}
